customElements.component = 'custom-product-options-wrapper';

if (!customElements.get(customElements.component)) {
  class CustomProductForm extends HTMLElement {
    constructor() {
      super();
      this.fakeSelectWrappers = [];
      this.originalSelects = [];
      this.fakeActionBtn = document.querySelector('[data-select-options-btn]');
      this.realActionBtn = document.querySelector('[data-add-to-cart-button]');
      this.form = document.querySelector('[data-type="add-to-cart-form"]');
      this.yearInput = this.form?.querySelector('[data-year-selector]');
      this.infoInput = this.form?.querySelector('[data-info-selector]');

      // Bind methods
      this.handleFakeSelectClick = this.handleFakeSelectClick.bind(this);
      this.handleOptionClick = this.handleOptionClick.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.updateActionButtonState = this.updateActionButtonState.bind(this);
      this.handleFakeActionClick = this.handleFakeActionClick.bind(this);
      this.updateColorLinks = this.updateColorLinks.bind(this);

    }

    connectedCallback() {
      this.initFakeSelects();
      this.preselectOptions();
      this.addEventListeners();
      this.updateActionButtonState(); // Initial state check
      this.updateColorLinks(); // Update color links with current URL parameters

      // Add styles for text truncation in select buttons
      const style = document.createElement('style');
      style.textContent = `
        .fake-select-button {
          display: flex;
          align-items: center;
          max-width: 100%;
        }
        .fake-select-button .fake-select-value {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: calc(100% - 30px); /* Reserve space for the dropdown arrow */
          display: inline-block;
        }
        .fake-select-dropdown .fake-select-option {
          white-space: normal;
          word-break: break-word;
          padding: 8px 12px;
        }
      `;
      document.head.appendChild(style);

      // Add red borders to unselected inputs on page load
      this.fakeSelectWrappers.forEach(wrapper => {
        const button = wrapper.querySelector('.fake-select-button');
        const valueDisplay = button?.querySelector('.fake-select-value');
        if (valueDisplay && valueDisplay.textContent.includes('Select ')) {
          button.style.border = '1px solid red';
        }
      });

      console.log('CustomProductForm initialized');
    }

    disconnectedCallback() {
      this.removeEventListeners();
      console.log('CustomProductForm disconnected');
    }

    initFakeSelects() {
      this.fakeSelectWrappers = this.querySelectorAll('[data-fake-select-wrapper]');
      this.originalSelects = []; // Clear before re-init

      this.fakeSelectWrappers.forEach(wrapper => {
        const originalSelect = wrapper.parentElement.querySelector('select');
        const fakeButton = wrapper.querySelector('.fake-select-button');
        const dropdown = wrapper.querySelector('.fake-select-dropdown');

        if (originalSelect && fakeButton && dropdown) {
          // Store refs if needed, or just attach listeners
          this.originalSelects.push(originalSelect);

          // Hide original select visually if CSS didn't catch it (redundancy)
          originalSelect.style.position = 'absolute';
          originalSelect.style.opacity = '0';
          originalSelect.style.pointerEvents = 'none';
          originalSelect.style.height = '0';
          originalSelect.style.width = '0';
        } else {
          console.warn('Missing elements for fake select in wrapper:', wrapper);
        }
      });
    }

    addEventListeners() {
      this.fakeSelectWrappers.forEach(wrapper => {
        const fakeButton = wrapper.querySelector('.fake-select-button');
        const dropdown = wrapper.querySelector('.fake-select-dropdown');
        if (fakeButton) {
          fakeButton.addEventListener('click', this.handleFakeSelectClick);
        }
        if (dropdown) {
          dropdown.addEventListener('click', this.handleOptionClick);
        }
      });
      document.addEventListener('click', this.handleDocumentClick);

      // Listen to changes on original selects if other scripts modify them
      this.originalSelects.forEach(select => {
         select.addEventListener('change', this.updateActionButtonState); 
      });

      if (this.fakeActionBtn) {
        this.fakeActionBtn.addEventListener('click', this.handleFakeActionClick);
      }
    }

    removeEventListeners() {
       this.fakeSelectWrappers.forEach(wrapper => {
        const fakeButton = wrapper.querySelector('.fake-select-button');
        const dropdown = wrapper.querySelector('.fake-select-dropdown');
        if (fakeButton) {
          fakeButton.removeEventListener('click', this.handleFakeSelectClick);
        }
        if (dropdown) {
          dropdown.removeEventListener('click', this.handleOptionClick);
        }
      });
      document.removeEventListener('click', this.handleDocumentClick);

      this.originalSelects.forEach(select => {
         select.removeEventListener('change', this.updateActionButtonState);
      });

       if (this.fakeActionBtn) {
        this.fakeActionBtn.removeEventListener('click', this.handleFakeActionClick);
      }
    }

    handleFakeSelectClick(event) {
      const button = event.currentTarget;
      const wrapper = button.closest('[data-fake-select-wrapper]');
      const isOpen = wrapper.classList.contains('is-open');

      // Close all other open dropdowns first
      this.closeAllDropdowns(wrapper);

      wrapper.classList.toggle('is-open', !isOpen);
      button.setAttribute('aria-expanded', !isOpen);
    }

    handleOptionClick(event) {
      if (!event.target.classList.contains('fake-select-option')) return;

      const selectedOption = event.target;
      const wrapper = selectedOption.closest('[data-fake-select-wrapper]');
      const dropdown = wrapper.querySelector('.fake-select-dropdown');
      const button = wrapper.querySelector('.fake-select-button');
      const valueDisplay = button.querySelector('.fake-select-value');
      const originalSelect = wrapper.parentElement.querySelector('select');

      const newValue = selectedOption.dataset.value;
      const newText = selectedOption.textContent.trim();

      // Update original select
      originalSelect.value = newValue;

      // Update fake select display
      valueDisplay.textContent = newText;
      dropdown.querySelectorAll('.fake-select-option').forEach(opt => opt.classList.remove('is-selected'));
      selectedOption.classList.add('is-selected');
      
      // Remove red border when option is selected
      button.style.border = '';

      // Close dropdown
      wrapper.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');

      // Handle specific select logic
      const selectTypeWrapper = wrapper.closest('[data-select-wrapper]');
      const selectType = selectTypeWrapper ? selectTypeWrapper.dataset.selectWrapper : (wrapper.closest('.product-option-selector') ? 'style' : null);
      
      if (selectType === 'models') {
        const redirectUrl = selectedOption.dataset.url;
        const noRedirect = selectedOption.hasAttribute('data-no-redirect');
        if (redirectUrl && !noRedirect) {
          // Preserve current URL parameters but remove preselect_model and preselect_model
          const currentParams = new URLSearchParams(window.location.search);
          currentParams.delete('preselect_model');
          currentParams.delete('preselect_model');
          const newUrl = new URL(redirectUrl, window.location.origin);
          newUrl.search = currentParams.toString();
          window.location.href = newUrl.toString();
          return; // Stop further processing if redirecting
        }
      }

      // Update URL parameter for all select types
      if (selectType) {
        this.updateUrlParameter(selectType, newValue);
      }

      // Update hidden inputs if needed
      if (selectType === 'year' && this.yearInput) {
        this.yearInput.value = newValue;
      } else if (selectType === 'info' && this.infoInput) {
        this.infoInput.value = newValue;
      }

      // Dispatch change event on original select for compatibility
      originalSelect.dispatchEvent(new Event('change', { bubbles: true }));

      this.updateActionButtonState();
      
      // Update color links with current URL parameters after any select change
      this.updateColorLinks();
    }

    handleDocumentClick(event) {
      // Close dropdown if click is outside any fake select wrapper
      if (!event.target.closest('[data-fake-select-wrapper]')) {
        this.closeAllDropdowns();
      }
    }

    closeAllDropdowns(excludeWrapper = null) {
      this.fakeSelectWrappers.forEach(wrapper => {
        if (wrapper !== excludeWrapper) {
          wrapper.classList.remove('is-open');
          wrapper.querySelector('.fake-select-button')?.setAttribute('aria-expanded', 'false');
        }
      });
    }

    preselectOptions() {
      const params = new URLSearchParams(window.location.search);
      const variantId = params.get('variant');
      const urlYear = params.get('year');
      const urlInfo = params.get('info');
      const urlModel = params.get('models');
      const urlStyle = params.get('style');
      const preventModelPreselect = params.get('preselect_model') === 'false';
      const notPreselect = params.get('preselect_model') === 'true';
      
      console.log('URL Parameters:', { year: urlYear, info: urlInfo, model: urlModel, style: urlStyle, preventModelPreselect, notPreselect });

      // Update hidden inputs first based on URL parameters
      if (urlYear && this.yearInput) {
        this.yearInput.value = urlYear;
      }
      
      if (urlInfo && this.infoInput) {
        this.infoInput.value = decodeURIComponent(urlInfo);
      }

      this.fakeSelectWrappers.forEach(wrapper => {
        const originalSelect = wrapper.parentElement.querySelector('select');
        const options = wrapper.querySelectorAll('.fake-select-option');
        const button = wrapper.querySelector('.fake-select-button');
        const valueDisplay = button.querySelector('.fake-select-value');
        const dropdown = wrapper.querySelector('.fake-select-dropdown');
        let preselected = false;

        // Check if we're dealing with a variant/style dropdown
        const isVariantOption = wrapper.closest('.product-option-selector') !== null;
        const selectTypeWrapper = wrapper.closest('[data-select-wrapper]');
        const selectType = selectTypeWrapper ? selectTypeWrapper.dataset.selectWrapper : (isVariantOption ? 'style' : null);
        
        // Get the URL parameter value for this select type
        let urlValue = null;
        if (selectType === 'year') urlValue = urlYear;
        else if (selectType === 'info') urlValue = urlInfo;
        else if (selectType === 'models') urlValue = urlModel;
        else if (selectType === 'style') urlValue = urlStyle;

        // Special handling for model preselection
        if (selectType === 'models') {
          // First check for data-selected attribute in original select
          const selectedOption = originalSelect.querySelector('option[data-selected="true"]');
          if (selectedOption && !notPreselect) {
            const matchingFakeOption = Array.from(options).find(opt => opt.dataset.value === selectedOption.value);
            if (matchingFakeOption) {
              this.selectOption(matchingFakeOption, wrapper, originalSelect, true);
              preselected = true;
            }
          }
          // If no data-selected option, try URL parameter
          else if (urlValue && !preventModelPreselect && !notPreselect) {
            const modelOption = Array.from(options).find(opt => opt.dataset.value === urlValue);
            if (modelOption) {
              this.selectOption(modelOption, wrapper, originalSelect, true);
              preselected = true;
            }
          }
        }
        // Handle other preselections
        else if (urlValue && !notPreselect) {
          console.log(`Trying to preselect ${selectType} with value from URL:`, urlValue);
          
          options.forEach(option => {
            if (option.dataset.value === urlValue) {
              console.log(`Found matching option from URL:`, option.dataset.value);
              this.selectOption(option, wrapper, originalSelect, true);
              preselected = true;
            }
          });
        }

        // If no URL parameter or no match found, show placeholder
        if (!preselected) {
          const placeholder = originalSelect.querySelector('option[value=""]') || originalSelect.querySelector('option:disabled');
          if (placeholder && valueDisplay) {
            valueDisplay.textContent = placeholder.textContent;
            // Ensure no option is selected in the dropdown
            if (dropdown) {
              dropdown.querySelectorAll('.fake-select-option').forEach(opt => opt.classList.remove('is-selected'));
            }
          }
        }
      });
    }

    // Helper to select an option and update UI/state
    selectOption(optionElement, wrapper, originalSelect, isPreselecting = false) {
      const button = wrapper.querySelector('.fake-select-button');
      const valueDisplay = button.querySelector('.fake-select-value');
      const dropdown = wrapper.querySelector('.fake-select-dropdown');
      const newValue = optionElement.dataset.value;
      const newText = optionElement.textContent.trim();

      // Update original select
      originalSelect.value = newValue;

      // Update fake select display
      valueDisplay.textContent = newText;
      dropdown.querySelectorAll('.fake-select-option').forEach(opt => opt.classList.remove('is-selected'));
      optionElement.classList.add('is-selected');
      wrapper.classList.remove('has-error');

      // Update hidden inputs if year/info during preselection
      if (isPreselecting) {
        const selectTypeWrapper = wrapper.closest('[data-select-wrapper]');
        const selectType = selectTypeWrapper ? selectTypeWrapper.dataset.selectWrapper : null;
        if (selectType === 'year' && this.yearInput) {
          this.yearInput.value = newValue;
        } else if (selectType === 'info' && this.infoInput) {
          this.infoInput.value = newValue;
        }
        // Dispatch change event
        originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update action button state after selecting option
      this.updateActionButtonState();
    }

    // Helper method to update URL parameter without reloading page
    updateUrlParameter(key, value) {
      if (!window.history || !window.history.pushState) return; // Exit if history API not supported

      // Get current URL and parameters
      const url = new URL(window.location.href);
      
      // Update parameters
      if (value === '') {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value);
      }
      
      // Remove preselect_model and preselect_model parameters
      url.searchParams.delete('preselect_model');
      url.searchParams.delete('preselect_model');
      
      // Get the new URL string
      const newUrl = url.toString();
      
      console.log(`Updating URL parameter: ${key}=${value}, New URL: ${newUrl}`);
      
      // Update URL without page reload
      window.history.pushState({ path: newUrl }, '', newUrl);
    }

    updateActionButtonState() {
      if (!this.fakeActionBtn) return; // Only run if the fake button exists

      let allSelected = true;
      
      // Check all original selects
      this.originalSelects.forEach(select => {
        if (!select.value) {
          allSelected = false;
        }
      });

      // Check all fake selects
      this.fakeSelectWrappers.forEach(wrapper => {
        const button = wrapper.querySelector('.fake-select-button');
        const valueDisplay = button?.querySelector('.fake-select-value');
        if (valueDisplay && valueDisplay.textContent.includes('Select ')) {
          allSelected = false;
        }
      });

      // Update button state
      if (allSelected) {
        this.fakeActionBtn.disabled = false;
        this.fakeActionBtn.textContent = 'Add to cart';
        if (this.realActionBtn) {
          this.realActionBtn.style.display = 'none';
        }
      } else {
        this.fakeActionBtn.disabled = true;
        this.fakeActionBtn.textContent = 'Select options';
        if (this.realActionBtn) {
          this.realActionBtn.style.display = 'none';
        }
      }
    }

    handleFakeActionClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.fakeActionBtn.disabled) {
            // Add red border to all unselected inputs
            this.fakeSelectWrappers.forEach(wrapper => {
                const button = wrapper.querySelector('.fake-select-button');
                const valueDisplay = button?.querySelector('.fake-select-value');
                if (valueDisplay && valueDisplay.textContent.includes('Select ')) {
                    button.style.border = '1px solid red';
                }
            });
        } else {
            // Trigger click on the real button
            if (this.realActionBtn) {
                this.realActionBtn.click();
            } else {
                console.error('Real add to cart button not found!');
            }
        }
    }

    updateColorLinks() {
      // Get all color links in the connected colors section
      const colorLinks = document.querySelectorAll('.connected_colors__item');
      if (!colorLinks.length) return;

      // Get current URL parameters
      const currentParams = new URLSearchParams(window.location.search);
      
      colorLinks.forEach(link => {
        // Skip if link has no href
        if (!link.href) return;
        
        // Create URL object from the link's href
        const url = new URL(link.href, window.location.origin);
        
        // Clear existing parameters and add all current parameters to the color link's URL
        url.search = ''; // Clear existing parameters
        currentParams.forEach((value, key) => {
          url.searchParams.set(key, value);
        });
        
        // Update the link's href with the new URL
        link.href = url.toString();
      });
    }
  }

  customElements.define('custom-product-options-wrapper', CustomProductForm);
};

// Rating badge: scroll to the Judge.me reviews widget; fall back to the link href if it isn't on the page
document.addEventListener('click', (event) => {
  const badgeLink = event.target.closest('[data-scroll-to-reviews]');
  if (!badgeLink) return;

  const reviews = document.querySelector('.jdgm-all-reviews-widget-v2025, .jdgm-review-widget, #judgeme_product_reviews');
  if (!reviews) {
    if (badgeLink.getAttribute('href') === '#') event.preventDefault();
    return;
  }

  event.preventDefault();
  reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
});